const links = {
  data_url: "https://www.hussle.tech/data",
  privacy_url: "https://www.hussle.tech/privacy",
  terms_url: "https://www.hussle.tech/terms",
};

export default links;
